import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';

var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "min-w-0 w-full" },
    [
      _c(
        VCard,
        [
          _c(VDataTable, {
            key: _vm.keySomos1Reports,
            staticClass: "text-center table-inca",
            attrs: {
              responsive: "",
              hover: "",
              items: _vm.items,
              headers: _vm.headers,
              "hide-default-footer": "",
              "disable-pagination": "",
            },
            scopedSlots: _vm._u([
              {
                key: "header.maintenance",
                fn: function (ref) {
                  var header = ref.header
                  return [
                    _c(
                      VTooltip,
                      {
                        attrs: { bottom: "" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "activator",
                              fn: function (ref) {
                                var on = ref.on
                                var attrs = ref.attrs
                                return [
                                  _c(
                                    VBtn,
                                    _vm._g(
                                      _vm._b(
                                        {
                                          staticClass: "btn-icon-inca",
                                          attrs: { icon: "", small: "" },
                                          on: { click: _vm.changeMaintenance },
                                        },
                                        "v-btn",
                                        attrs,
                                        false
                                      ),
                                      on
                                    ),
                                    [
                                      _c(VIcon, [
                                        _vm._v(
                                          "mdi-toggle-switch-off-outline "
                                        ),
                                      ]),
                                    ],
                                    1
                                  ),
                                ]
                              },
                            },
                          ],
                          null,
                          true
                        ),
                      },
                      [_c("span", [_vm._v("Cambiar estado")])]
                    ),
                    _vm._v(" MAINTENANCE "),
                  ]
                },
              },
              {
                key: "item.maintenance",
                fn: function (ref) {
                  var item = ref.item
                  return [
                    _c("div", [
                      _vm._v(_vm._s(item.maintenance == true ? "Si" : "No")),
                    ]),
                  ]
                },
              },
              {
                key: "item.tags",
                fn: function (ref) {
                  var item = ref.item
                  return _vm._l(item.tags, function (tag, index) {
                    return _c(
                      VChip,
                      {
                        key: index,
                        staticClass: "caption small m-1",
                        staticStyle: { "white-space": "nowrap" },
                        attrs: { color: "primary" },
                      },
                      [_vm._v(" " + _vm._s(tag) + " ")]
                    )
                  })
                },
              },
              {
                key: "item.actions",
                fn: function (ref) {
                  var item = ref.item
                  return [
                    _c(
                      VTooltip,
                      {
                        attrs: { bottom: "" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "activator",
                              fn: function (ref) {
                                var on = ref.on
                                var attrs = ref.attrs
                                return [
                                  _c(
                                    VBtn,
                                    _vm._g(
                                      _vm._b(
                                        {
                                          staticClass: "btn-icon-inca",
                                          attrs: { icon: "", small: "" },
                                          on: {
                                            click: function ($event) {
                                              return _vm.onOpenDialog(
                                                item,
                                                _vm.DIALOG_MANAGE_USERS
                                              )
                                            },
                                          },
                                        },
                                        "v-btn",
                                        attrs,
                                        false
                                      ),
                                      on
                                    ),
                                    [
                                      _c(VIcon, [
                                        _vm._v("mdi-account-multiple"),
                                      ]),
                                    ],
                                    1
                                  ),
                                ]
                              },
                            },
                          ],
                          null,
                          true
                        ),
                      },
                      [_c("span", [_vm._v("Editar usuarios")])]
                    ),
                    _vm.isInsishtsAdmin
                      ? _c(
                          VTooltip,
                          {
                            attrs: { bottom: "" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "activator",
                                  fn: function (ref) {
                                    var on = ref.on
                                    var attrs = ref.attrs
                                    return [
                                      _c(
                                        VBtn,
                                        _vm._g(
                                          _vm._b(
                                            {
                                              staticClass: "btn-icon-inca",
                                              attrs: { icon: "", small: "" },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.onOpenDialog(
                                                    item,
                                                    _vm.DIALOG_UPDATE_REPORT
                                                  )
                                                },
                                              },
                                            },
                                            "v-btn",
                                            attrs,
                                            false
                                          ),
                                          on
                                        ),
                                        [_c(VIcon, [_vm._v("mdi-pencil")])],
                                        1
                                      ),
                                    ]
                                  },
                                },
                              ],
                              null,
                              true
                            ),
                          },
                          [_c("span", [_vm._v("Editar campos")])]
                        )
                      : _vm._e(),
                    _vm.isInsishtsAdmin
                      ? _c(
                          VTooltip,
                          {
                            attrs: { bottom: "" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "activator",
                                  fn: function (ref) {
                                    var on = ref.on
                                    var attrs = ref.attrs
                                    return [
                                      _c(
                                        VBtn,
                                        _vm._g(
                                          _vm._b(
                                            {
                                              staticClass: "btn-icon-inca",
                                              attrs: { icon: "", small: "" },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.onOpenDialog(
                                                    item,
                                                    _vm.DIALOG_DELETE_REPORT
                                                  )
                                                },
                                              },
                                            },
                                            "v-btn",
                                            attrs,
                                            false
                                          ),
                                          on
                                        ),
                                        [_c(VIcon, [_vm._v("icon-delete")])],
                                        1
                                      ),
                                    ]
                                  },
                                },
                              ],
                              null,
                              true
                            ),
                          },
                          [_c("span", [_vm._v("Eliminar reporte")])]
                        )
                      : _vm._e(),
                    _vm.isInsishtsAdmin
                      ? _c(
                          VTooltip,
                          {
                            attrs: { bottom: "" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "activator",
                                  fn: function (ref) {
                                    var on = ref.on
                                    var attrs = ref.attrs
                                    return [
                                      _c(
                                        VBtn,
                                        _vm._g(
                                          _vm._b(
                                            {
                                              staticClass: "btn-icon-inca",
                                              attrs: { icon: "", small: "" },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.onOpenDialog(
                                                    item,
                                                    _vm.DIALOG_DICTIONARY
                                                  )
                                                },
                                              },
                                            },
                                            "v-btn",
                                            attrs,
                                            false
                                          ),
                                          on
                                        ),
                                        [
                                          _c(VIcon, [
                                            _vm._v("mdi-table-large"),
                                          ]),
                                        ],
                                        1
                                      ),
                                    ]
                                  },
                                },
                              ],
                              null,
                              true
                            ),
                          },
                          [_c("span", [_vm._v("Diccionario")])]
                        )
                      : _vm._e(),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
      _c("dialogs-component", {
        ref: _vm.DIALOG_MANAGE_USERS,
        attrs: { title: _vm.manage_users_title, width: 600 },
        scopedSlots: _vm._u([
          {
            key: "body",
            fn: function () {
              return [
                _c("edit-users-report-component", {
                  attrs: { item: _vm.item },
                }),
              ]
            },
            proxy: true,
          },
        ]),
      }),
      _c("dialogs-component", {
        ref: _vm.DIALOG_CREATE_REPORT,
        attrs: { title: "Añadir reporte", width: 900 },
        scopedSlots: _vm._u([
          {
            key: "body",
            fn: function () {
              return [
                _c("FormSomos1ReportComponent", {
                  ref: "formSomos1DashboardCreate",
                  on: { SubmitReport: _vm.onAddReport },
                }),
              ]
            },
            proxy: true,
          },
          {
            key: "btnsRight",
            fn: function () {
              return [
                _c(
                  VBtn,
                  {
                    attrs: { color: "primary" },
                    on: {
                      click: function ($event) {
                        return _vm.$refs.formSomos1DashboardCreate.onSubmit(
                          $event
                        )
                      },
                    },
                  },
                  [
                    _c(VIcon, { attrs: { left: "" } }, [
                      _vm._v("icon-send"),
                    ]),
                    _vm._v(" " + _vm._s(_vm.$t("common.add")) + " "),
                  ],
                  1
                ),
              ]
            },
            proxy: true,
          },
        ]),
      }),
      _c("dialogs-component", {
        ref: _vm.DIALOG_UPDATE_REPORT,
        attrs: { title: _vm.manage_report_title, width: 900 },
        scopedSlots: _vm._u([
          {
            key: "body",
            fn: function () {
              return [
                _c("FormSomos1ReportComponent", {
                  ref: "formSomos1DashboardUpdate",
                  attrs: { item: _vm.item },
                  on: { SubmitReport: _vm.onUpdateReport },
                }),
              ]
            },
            proxy: true,
          },
          {
            key: "btnsRight",
            fn: function () {
              return [
                _c(
                  VBtn,
                  {
                    attrs: { color: "primary" },
                    on: {
                      click: function ($event) {
                        return _vm.$refs.formSomos1DashboardUpdate.onSubmit(
                          $event
                        )
                      },
                    },
                  },
                  [
                    _c(VIcon, { attrs: { left: "" } }, [
                      _vm._v("icon-send"),
                    ]),
                    _vm._v(" " + _vm._s(_vm.$t("common.save")) + " "),
                  ],
                  1
                ),
              ]
            },
            proxy: true,
          },
        ]),
      }),
      _c("dialogs-component", {
        ref: _vm.DIALOG_DICTIONARY,
        attrs: { title: _vm.manage_dictionary_title, width: 900 },
        scopedSlots: _vm._u([
          {
            key: "body",
            fn: function () {
              return [
                _c("DashboardDictionaryDatatable", {
                  ref: "DashboardDictionaryDatatable",
                  attrs: { item: _vm.item },
                }),
                _c("DashboardDictionaryUpload", {
                  ref: "DashboardDictionaryUpload",
                  attrs: { item: _vm.item },
                  on: {
                    submitAfterDictionaryUpdate: _vm.onAfterDictionaryUpdate,
                  },
                }),
              ]
            },
            proxy: true,
          },
          {
            key: "btnsRight",
            fn: function () {
              return [
                _c(
                  VBtn,
                  {
                    attrs: { color: "primary" },
                    on: { click: _vm.showUploadBox },
                  },
                  [
                    _c(VIcon, { attrs: { left: "" } }, [
                      _vm._v("mdi-upload-outline"),
                    ]),
                    _vm._v(" " + _vm._s(_vm.$t("common.register")) + " "),
                  ],
                  1
                ),
                _c(
                  VBtn,
                  {
                    attrs: { color: "primary" },
                    on: {
                      click: function ($event) {
                        return _vm.$refs.DashboardDictionaryUpload.downloadTemplate(
                          $event
                        )
                      },
                    },
                  },
                  [
                    _c(VIcon, { attrs: { left: "" } }, [
                      _vm._v("mdi-download-outline"),
                    ]),
                    _vm._v(
                      " " + _vm._s(_vm.$t("common.download_template")) + " "
                    ),
                  ],
                  1
                ),
              ]
            },
            proxy: true,
          },
        ]),
      }),
      _c("dialog-confirmation-component", {
        ref: _vm.DIALOG_DELETE_REPORT,
        on: { onConfirm: _vm.onConfirmDelete },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }